"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class avatarStatus {
    constructor($timeout) {
        this.$timeout = $timeout;
        this.customScope = undefined;
        this.scope = {
            color: "<",
            title: "@",
            contact: "<",
            fontSize: "<",
        };
        this.restrict = "E";
        this.templateUrl = "assets/javascripts/xchelper/directives/avatarStatus.html";
        this.link = (scope, element, attrs) => {
            this.$timeout(() => {
                const customScope = scope;
                let avatarStatusDiv = element[0];
                const parentElement = avatarStatusDiv.querySelector('.avatar-status > .avatar-circle');
                if (!avatarStatusDiv)
                    return;
                const spanToChange = parentElement === null || parentElement === void 0 ? void 0 : parentElement.querySelector(".contact-initials");
                if (!spanToChange)
                    return;
                if (!(customScope === null || customScope === void 0 ? void 0 : customScope.contact.isMeetingroom)) {
                    element.on("mouseenter", () => {
                        element[0].style.cursor = "pointer";
                        spanToChange.textContent = "";
                        spanToChange.className = "contact-initials fa fa-phone";
                        spanToChange.style.color = this.getPhoneIconColor(customScope.color);
                        spanToChange.style.fontSize = customScope.fontSize;
                        spanToChange.style.transform = "rotate(75deg)";
                    });
                    element.on("mouseleave", () => {
                        element[0].style.cursor = "default";
                        spanToChange.textContent = customScope.contact.initials || "";
                        spanToChange.className = "contact-initials";
                        spanToChange.style.color = "";
                        spanToChange.style.fontSize = "";
                        spanToChange.style.transform = "";
                    });
                }
            }, 0);
        };
    }
    getPhoneIconColor(phoneState) {
        switch (phoneState) {
            case "user-status0":
                return "#5cb85c";
            case "user-status1":
                return "#ff5722";
            case "user-status2":
                return "#81BEF7";
            case "user-status4":
            case "user-status-2":
                return "grey";
            case "user-status8":
                return "#2E2EFE";
            case "user-status9":
                return "#CC2EFA";
            case "user-status16":
                ;
                return "#F7FE2E";
            case "user-status-dnd":
                return "#ff0000";
            default:
                return "";
        }
    }
}
exports.default = avatarStatus;
avatarStatus.$inject = ["$timeout"];
